import { api } from "../../../services/rpc/RpcProvider";

export const useDatasetSyncLogs = (datasetId: string) => {
  const { data: logs, refetch } = api.datasets.sync.logs.useQuery({ datasetId });

  return { logs, refetch };
};
